import { Rpc } from "./rpc";

export class UserVacationCountRpc {

    public static get(): Promise<GetUserVacationCountResponse> {
        return Rpc.GET('/rpc/uservacationcount/get');
    }

    private constructor() {}

}

export interface GetUserVacationCountResponse {

    readonly annualVacationCount: string;
    readonly carriedVacationCount: string;
    readonly usedUpVacationCount: string;
    readonly remainingVacationCount: string;

}